const BUSINESS_TYPES = [
  { code: 'BUSINESS_TYPE_HOMEMADE', title: 'خانگی' },
  {
    code: 'BUSINESS_TYPE_PERSONAL_WITHOUT_ECONOMIC_CODE',
    title: 'کسب‌وکار شخصی بدون کد اقتصادی',
  },
  {
    code: 'BUSINESS_TYPE_PERSONAL_WITH_ECONOMIC_CODE',
    title: 'کسب‌وکار شخصی با کد اقتصادی',
  },
  {
    code: 'BUSINESS_TYPE_LEGAL_WITHOUT_ECONOMIC_CODE',
    title: 'کسب‌وکار حقوقی بدون کد اقتصادی',
  },
  {
    code: 'BUSINESS_TYPE_LEGAL_WITH_ECONOMIC_CODE',
    title: 'کسب‌وکار حقوقی با کد اقتصادی',
  },
  { code: 'BUSINESS_TYPE_WHITE_LIST', title: 'کسب‌وکار لیست سفید' },
];

export default BUSINESS_TYPES;
